module.exports = __webpack_public_path__ + "img/box-spcschedule.46589a56.png";